import type { RouteObject } from 'react-router-dom';

import { Layout } from './components/Layout';
import { Home } from './pages/Home';
import { DiscoverRedirect } from './pages/DiscoverRedirect';
import { SourcePage } from './pages/SourcePage';
import { ComicPage } from './pages/ComicPage';
import { ReaderPage } from './pages/ReaderPage';
import { FavoritesPage } from './pages/FavoritesPage';
import { HistoryPage } from './pages/HistoryPage';
import { SettingsPage } from './pages/SettingsPage';
import { ConnectAccountPage } from './pages/ConnectAccountPage';
import { AccountPage, AccountProfilePage } from './pages/AccountPage';
import { MorePage } from './pages/MorePage';
import { NotFound } from './pages/NotFound';
import { AppShell } from './features/pwa';

/**
 * Data-driven routing. The reader/comic/source/connect paths are parameterized
 * on a generic `:sourceId` — the registry resolves it. Adding a new source
 * requires zero edits to this file.
 *
 * The reader route is intentionally *outside* the `<Layout>` shell so it can
 * own its own header / toolbar / progress bar without the app chrome eating
 * vertical pixels. Every other route nests under the shared Layout. Both
 * sit under a thin `<AppShell>` so PWA install UX is available everywhere.
 */
export const routes: RouteObject[] = [
  {
    element: <AppShell />,
    children: [
      {
        path: 'source/:sourceId/comic/:comicId/read/:page?',
        element: <ReaderPage />,
      },
      {
        element: <Layout />,
        children: [
          { index: true, element: <Home /> },
          { path: 'recommended', element: <DiscoverRedirect /> },
          { path: 'search', element: <DiscoverRedirect /> },
          { path: 'source/:sourceId', element: <SourcePage /> },
          { path: 'source/:sourceId/comic/:comicId', element: <ComicPage /> },
          { path: 'connect/:sourceId', element: <ConnectAccountPage /> },
          // `/library` is the unified cross-source view. `/library/favorites`
          // is kept as an alias so existing nav links / browser history /
          // bookmarks don't break.
          { path: 'library', element: <FavoritesPage /> },
          { path: 'library/favorites', element: <FavoritesPage /> },
          { path: 'library/history', element: <HistoryPage /> },
          { path: 'more', element: <MorePage /> },
          { path: 'account', element: <AccountPage /> },
          { path: 'account/profile/*', element: <AccountProfilePage /> },
          { path: 'settings', element: <SettingsPage /> },
          { path: '*', element: <NotFound /> },
        ],
      },
    ],
  },
];
